<template>
    <div class="addMeeting">
        <el-dialog :title="isEdit ? '编辑会议' : '新建会议'" :visible.sync="newDialogVisible" width="460px" center
            custom-class="newBuildMeeting" v-if="newDialogVisible" :before-close="cancelVisible"
            :close-on-click-modal="false">
			<div class="" slot="title" style="text-align: left;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;">
				{{isEdit ? '编辑会议' : '新建会议'}}
			</div>
			
            <el-form :model="ruleForm"  ref="ruleForm" label-width="100px" class="demo-ruleForm"
                :rules="rules" label-position="left" >
                <el-form-item label="案号" prop="subject" >
                    <el-input type="text" v-model="ruleForm.subject" autocomplete="off" placeholder="请输入案号"></el-input>
                </el-form-item>
                <el-form-item label="会议名称" prop="name">
                    <el-input type="text" v-model="ruleForm.name" autocomplete="off" 
                        placeholder="请输入会议名称"></el-input>
                </el-form-item>
				<el-form-item label="会议时间" prop="startTime">
					<div class="" style="width: 65%;">
						<datePicker :dateRange="ruleForm.startTime" @change="changess"></datePicker>
					</div> 
					
					<!-- <div class="flex align-center justify-between">
						<el-date-picker prefix-icon="noen" v-model="ruleForm.startTime" type="datetime" placeholder="选择日期时间" clearable>
							<div class="el-icon-riqi">
								
							</div>
						 </el-date-picker>
					</div> -->
					
				</el-form-item>
                <el-form-item label="发起人" prop="sponsor">
                    <el-input type="text" v-model="ruleForm.sponsor" autocomplete="off" placeholder="请输入发起人"></el-input>
                </el-form-item>
                <el-form-item label="管理人" prop="managerUserId">
                    <el-select v-model="ruleForm.managerUserId" filterable placeholder="请选择管理人">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否实名认证" prop="signature">
                    <el-switch v-model="ruleForm.signature"> </el-switch>
                </el-form-item>
				<el-form-item label="是否签字" prop="normalSign">
				    <el-switch v-model="ruleForm.normalSign"> </el-switch>
				</el-form-item>
                <el-form-item label="是否禁用下载" prop="normalSign">
				    <el-switch v-model="ruleForm.banDownload"> </el-switch>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
				<!-- style="background: #de4d2a !important" -->
                <el-button @click="cancelVisible" style="padding: 9px 25px;margin-right: 20px;" plain>取消</el-button>
				<el-button type="primary" style="padding: 9px 25px;" @click="sureMeeting('ruleForm')"
				    :loading="loading">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { addMeeting, editMeeting } from '@/serve/meeting';
import datePicker from '@/components/datePicker';
export default {
    components: {
    	datePicker
    },
    props: {
        newDialogVisible: Boolean,
        isEdit: Boolean,
        managerList: Array,
        ruleForm: Object
    },
    computed: {
        options() {
            let options = [];
            this.managerList.forEach((item) => {
                options.push({
                    value: item.id,
                    label: item.name
                });
            });
            return options;
        }
    },
    data() {
        return {
            rules: {
                subject: [{ required: true, message: '请输入案号', trigger: 'blur' }],
                name: [{ required: true, message: '请输入会议名称', trigger: 'blur' }],
                startTime: [{ required: true, message: '请选择会议时间', trigger: 'blur' }],
                sponsor: [{ required: true, message: '请输入发起人', trigger: 'blur' }],
                managerUserId: [{ required: true, message: '请选择管理人', trigger: 'blur' }]
            },
            loading: false,
        };
    },
    methods: {
		changess(e){
			console.log("e:",e);
			this.ruleForm.startTime = e;
		},
        cancelVisible() {
            this.$refs.ruleForm.resetFields();
            this.$emit('cancel', 'newDialogVisible');
        },
        // 创建会议
        sureMeeting(formName) {
            let msg = this.isEdit ? '编辑' : '新增';
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    this.ruleForm.startTime = new Date(this.ruleForm.startTime).getTime();
                    try {
                        if (this.isEdit) {
                            await editMeeting(this.ruleForm.id, this.ruleForm);
                        } else {
                            await addMeeting(this.ruleForm);
                        }
                        this.cancelVisible();
                        this.$message.success(`${msg}会议成功`);
                        this.$emit('refreshList');
                    } catch (err) {
                        this.$message.error(`${msg}会议失败`);
                    }
                    this.loading = false;
                }
            });
        }
    }
};
</script>
<style lang="scss">
.el-dialog__header {
    // background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
    // background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
    // background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
    // background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
    // background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
    // background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
}

.el-dialog__headerbtn .el-dialog__close {
    color: rgba(40,47,54,0.3);
	font-size: 20px;
}
</style>
<style scoped lang="scss">

</style>
